// ============================================
// TEMA.JS — Sistema de temas claro/oscuro
// ============================================

import React, { createContext, useContext, useState, useEffect } from 'react';

export const TEMAS = {
  claro: {
    nombre: 'Claro',
    fondo: '#f3f4f4',
    superficie: '#ffffff',
    superficieSecundaria: '#f9fafb',
    sidebar: '#0f1923',
    sidebarTexto: 'rgba(255,255,255,0.7)',
    sidebarActivo: '#ffffff',
    texto: '#4e5357',
    textoSecundario: '#5e666e',
    borde: '#e0e0e0',
    bordeSuave: '#f0f0f0',
    inputBg: '#ffffff',
    hover: '#f0f7ff',
    logoSidebar: '/Logo Horizontal blanco.png',
    logoHeader: '/Logo Original Cuadrado.png',
  },
  oscuro: {
    nombre: 'Oscuro',
    fondo: '#0f1923',
    superficie: '#1a2535',
    superficieSecundaria: '#1e2d3d',
    sidebar: '#0a1520',
    sidebarTexto: 'rgba(255,255,255,0.6)',
    sidebarActivo: '#ffffff',
    texto: '#e2e8f0',
    textoSecundario: '#94a3b8',
    borde: '#2d3f55',
    bordeSuave: '#1e2d3d',
    inputBg: '#1a2535',
    hover: '#1e2d3d',
    logoSidebar: '/Logo Horizontal blanco.png',
    logoHeader: '/Logo Horizontal blanco.png',
  },
};

const TemaContext = createContext({ tema: TEMAS.claro, temaId: 'claro', setTemaId: () => {} });

export function TemaProvider({ children }) {
  const [temaId, setTemaId] = useState(() => localStorage.getItem('beep-tema') || 'claro');

  useEffect(() => {
    localStorage.setItem('beep-tema', temaId);
  }, [temaId]);

  const tema = TEMAS[temaId] || TEMAS.claro;

  return (
    <TemaContext.Provider value={{ tema, temaId, setTemaId }}>
      {children}
    </TemaContext.Provider>
  );
}

export function useTema() {
  return useContext(TemaContext);
}
